module.exports = __webpack_public_path__ + "img/video.3e40e7a8.jpeg";